<template>
  <main>
    <div class="search">
      <mt-search v-model="value">
        <mt-cell
          v-for="v in getSearchList"
          :key="v.id"
          :title="v.name"
          :value="v.PinYin"
          @click.native="selectedSub(v)">
        </mt-cell>
      </mt-search>
    </div>
    <dl class="hot" v-show="value.length === 0">
      <dt>热门</dt>
      <dd>
        <p v-for="v in hotCountry" :key="v.name" @click="selectedSub(v)">{{ v.name }}</p>
      </dd>
    </dl>
    <mt-index-list v-show="value.length === 0">
      <mt-index-section v-for="v in all" :key="v.title" :index="v.title">
        <mt-cell :title="sub.name" v-for="sub in v.list" :key="sub.id" @click.native="selectedSub(sub)"></mt-cell>
      </mt-index-section>
    </mt-index-list>
  </main>
</template>

<script>
export default {
  data () {
    return {
      value: '',
      all: [],
      hotCountry: [],
      searchList: []
    }
  },
  computed: {
    getSearchList () {
      const { searchList, value } = this;
      const result = searchList.filter(v => {
        return v.name.includes(value) || v.PinYin.includes(value) || v.PinYinCode.includes(value);
      });
      return result;
    }
  },
  created () {
    this.$axios.get('country/all').then(res => {
      const { all, hotCountry } = res;
      this.all = Object.keys(all).map(v => {
        return { title: v, list: all[v] }
      });
      this.searchList = Object.keys(all).reduce((arr, v) => {
        arr = [...arr, ...all[v]];
        return arr;
      }, []);
      this.hotCountry = hotCountry;
    })
  },
  methods: {
    selectedSub (item) {
      console.log('-----');
      const { id } = item;
      this.$router.push({ name: 'list', query: { id } });
    }
  }
}
</script>

<style scoped src="./search.css"></style>